import type { QueryClient } from '@tanstack/react-query';
import { customerNotificationsQueryKeyRoot } from '@/entities/customer-notification/api/customer-notifications/constants';
import { markCustomerNotificationsRead } from '@/entities/customer-notification/api/customer-notifications/server-actions';
import type { CustomerNotificationListResponse } from '@/entities/customer-notification/api/customer-notifications/types';
import { addNewsReadId } from './news-read-storage';

const patchNotificationsReadInCache = (queryClient: QueryClient, id: string) => {
    queryClient.setQueriesData<CustomerNotificationListResponse>(
        { queryKey: [...customerNotificationsQueryKeyRoot] },
        (old) => {
            if (!old?.items) return old;
            return {
                ...old,
                items: old.items.map((item) => (item.id === id ? { ...item, isRead: true } : item)),
            };
        },
    );
};

export const markNewsRead = async ({
    id,
    isLoggedIn,
    queryClient,
}: {
    id: string;
    isLoggedIn: boolean;
    queryClient: QueryClient;
}) => {
    patchNotificationsReadInCache(queryClient, id);
    addNewsReadId(id);
    if (isLoggedIn) {
        const ok = await markCustomerNotificationsRead([id]);
        if (!ok) {
            await queryClient.invalidateQueries({ queryKey: [...customerNotificationsQueryKeyRoot] });
        }
    }
};
